import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Checkbox } from '@notino/react-styleguide-v20';

import { IFundRaisingSettings } from '@model';
import { CartPrice } from '@sharedComponents/Prices';

import { messages } from '../messages';
import { IFundRaisingModel } from '../model';

import { FundRaisingTitle } from './components/FundRaisingTitle';
import { StyledInfo, StyledPrice } from './styled';

export const IconColumn =
  (onClickAction: () => void) =>
  ({ active, disabled }: { active: boolean; disabled: boolean }) => (
    <Checkbox checked={active} disabled={disabled} onChange={onClickAction} />
  );

export const BodyColumn = (settings: IFundRaisingSettings, onClickAction: () => void) => () => (
  <FundRaisingTitle image={settings.image} onClick={onClickAction} />
);

export const PriceColumn = (model: IFundRaisingModel, isDualPriceLayout: boolean) => () => (
  <CartPrice price={model.price} isDualPriceLayout={isDualPriceLayout} isColumnLayout={true} />
);

export const InfoColumn = (model: IFundRaisingModel, onClickAction: () => void) => () => (
  <StyledInfo onClick={onClickAction}>
    <FormattedMessage {...messages.fundRaiserDescription} values={{ price: <StyledPrice price={model.price} /> }} />
  </StyledInfo>
);
